export enum UserTier {
  TierOne = 1,
  TierTwo = 2,
  TierThree = 3,
}
